export const CONFIG = {
    // ZAPIER_API: "https://hooks.zapier.com/hooks/catch/3337393/arifj2/" // Timons Zapier End Point
     ZAPIER_API: "https://hooks.zapier.com/hooks/catch/3430297/wu4epr/"
}

export default CONFIG;



// WEBPACK FOOTER //
// ./src/config.js